import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/nothing.png'
import _imports_1 from '../../assets/map.png'


const _hoisted_1 = { class: "page1" }
const _hoisted_2 = {
  key: 0,
  class: "nothing"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "product card" }
const _hoisted_6 = { class: "per_pro" }
const _hoisted_7 = {
  key: 0,
  class: "tag_gray"
}
const _hoisted_8 = {
  key: 1,
  class: "tag_red"
}
const _hoisted_9 = { class: "createTime" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "领取地点", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "per_banner" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "per_info" }
const _hoisted_18 = { class: "items-center justify-between" }
const _hoisted_19 = { class: "dbCode" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("现场核销点此按钮")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "items-center justify-between",
  style: {"margin-top":"5px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dhrecordList.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dhrecordList, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (item.dhStatus == '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "已兑换"))
                : _createCommentVNode("", true),
              (item.dhStatus == '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "未兑换"))
                : _createCommentVNode("", true),
              _createVNode(_component_van_row, { class: "items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createTextVNode(" 抢购时间：" + _toDisplayString(item.createTime) + " ", 1),
                        _createElementVNode("div", {
                          class: "items-center",
                          onClick: ($event: any) => (_ctx.dialogAddress(item))
                        }, _hoisted_14, 8, _hoisted_10)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, { span: "8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: item.goodsImg,
                          alt: ""
                        }, null, 8, _hoisted_16)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, { span: "16" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(item.goodsName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, "兑换码：" + _toDisplayString(item.dhCode), 1),
                          _createVNode(_component_van_button, {
                            onClick: ($event: any) => (_ctx.comfirm(item.dhRecordId)),
                            style: _normalizeStyle(
                      item.writeOff == '1' &&  item.dhStatus == '0' ?' display:block' : 'display:none'
                    ),
                            type: "default",
                            class: "buying"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 2
                          }, 1032, ["onClick", "style"])
                        ]),
                        _hoisted_21
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 256))
  ]))
}